angular.module('ui.bootstrap.tabindex', [])

  .directive('uibTabindexToggle', function () {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        attrs.$observe('disabled', function (disabled) {
          attrs.$set('tabindex', disabled ? -1 : null);
        });
      }
    };
  });
angular.module('ui.bootstrap.paging', [])
  /**
   * Helper internal service for generating common controller code between the
   * pager and pagination components
   */
  .factory('uibPaging', ['$parse', '$rootScope', '$timeout', function ($parse, $rootScope, $timeout) {
    return {
      create: function (ctrl, $scope, $attrs) {
        ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
        ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
        ctrl._watchers = [];

        ctrl.init = function (ngModelCtrl, config) {
          ctrl.ngModelCtrl = ngModelCtrl;
          ctrl.config = config;

          ngModelCtrl.$render = function () {
            ctrl.render();

            //SEO HACK! CANONICAL LINKS FOR PAGED CONTENT
            const lastPage = $scope.totalPages;
            const currentPage = $scope.page;
            $rootScope.hasNextPage = currentPage && currentPage < lastPage;
            $rootScope.hasPreviousPage = currentPage && currentPage > 1;
            $timeout(function () {
              var attr = $('#next_Can').attr('href');
              var attr2 = $('#prev_Can').attr('href');

              if (attr || attr2)
                if ($rootScope.hasNextPage && !$rootScope.hasPreviousPage) {
                  attr = window.updateQueryStringParameter(attr, 'p', currentPage + 1);
                  $('#next_Can').attr('href', attr);
                }
                else if ($rootScope.hasNextPage && $rootScope.hasPreviousPage) {
                  attr = window.updateQueryStringParameter(attr, 'p', currentPage + 1);
                  $('#next_Can').attr('href', attr);

                  attr2 = window.updateQueryStringParameter(attr2, 'p', currentPage - 1 === 1 ? undefined : currentPage - 1);
                  $('#prev_Can').attr('href', attr2);
                }
                else if (!$rootScope.hasNextPage && $rootScope.hasPreviousPage) {
                  attr2 = window.updateQueryStringParameter(attr2, 'p', currentPage - 1 === 1 ? undefined : currentPage - 1);
                  $('#prev_Can').attr('href', attr2);
                }
            });
            //SEO HACK! ENDED
          };

          if ($attrs.itemsPerPage) {
            ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
              ctrl.itemsPerPage = parseInt(value, 10);
              // $scope.totalPages = ctrl.calculateTotalPages();
              // ctrl.updatePage();
            }));
          } else {
            ctrl.itemsPerPage = config.itemsPerPage;
          }

          ctrl._watchers.push($scope.$watch('totalItems', function (newTotal, oldTotal) {
            if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
              $scope.totalPages = ctrl.calculateTotalPages();
              ctrl.updatePage();
            }
          }));
        };

        ctrl.calculateTotalPages = function () {
          var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
          return Math.max(totalPages || 0, 1);
        };

        ctrl.render = function () {
          $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
        };

        $scope.selectPage = function (page, evt) {
          if (evt) {
            evt.preventDefault();
          }

          var clickAllowed = !$scope.ngDisabled || !evt;
          if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
            if (evt && evt.target) {
              evt.target.blur();
            }
            ctrl.ngModelCtrl.$setViewValue(page);
            ctrl.ngModelCtrl.$render();
          }
        };

        $scope.getText = function (key) {
          return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
        };

        $scope.noPrevious = function () {
          return $scope.page === 1;
        };

        $scope.noNext = function () {
          return $scope.page === $scope.totalPages;
        };

        ctrl.updatePage = function () {
          ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

          if ($scope.page > $scope.totalPages) {
            $scope.selectPage($scope.totalPages);
          } else {
            ctrl.ngModelCtrl.$render();
          }
        };

        $scope.$on('$destroy', function () {
          $rootScope.hasNextPage = 0;
          $rootScope.hasPreviousPage = 0;
          while (ctrl._watchers.length) {
            ctrl._watchers.shift()();
          }
        });
      }
    };
  }]);
angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
  .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
    var ctrl = this;
    // Setup configuration parameters
    var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
      rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
      forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
      boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
      pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) { return $scope.$parent.$eval($attrs.pageLabel, { $page: idx }); } : angular.identity;
    $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
    $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
    $attrs.$set('role', 'menu');

    uibPaging.create(this, $scope, $attrs);

    if ($attrs.maxSize) {
      ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
        maxSize = parseInt(value, 10);
        ctrl.render();
      }));
    }

    // Create page object used in template
    function makePage(number, text, isActive) {
      return {
        number: number,
        text: text,
        active: isActive
      };
    }

    function getPages(currentPage, totalPages) {
      var pages = [];

      // Default page limits
      var startPage = 1, endPage = totalPages;
      var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

      // recompute if maxSize
      if (isMaxSized) {
        if (rotate) {
          // Current page is displayed in the middle of the visible ones
          startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
          endPage = startPage + maxSize - 1;

          // Adjust if limit is exceeded
          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = endPage - maxSize + 1;
          }
        } else {
          // Visible pages are paginated with maxSize
          startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

          // Adjust last page if limit is exceeded
          endPage = Math.min(startPage + maxSize - 1, totalPages);
        }
      }

      // Add page number links
      for (var number = startPage; number <= endPage; number++) {
        var page = makePage(number, pageLabel(number), number === currentPage);
        pages.push(page);
      }

      // Add links to move between page sets
      if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
        if (startPage > 1) {
          if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }
          if (boundaryLinkNumbers) {
            if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
              var secondPageLink = makePage(2, '2', false);
              pages.unshift(secondPageLink);
            }
            //add the first page
            var firstPageLink = makePage(1, '1', false);
            pages.unshift(firstPageLink);
          }
        }

        if (endPage < totalPages) {
          if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
          if (boundaryLinkNumbers) {
            if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
              var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
              pages.push(secondToLastPageLink);
            }
            //add the last page
            var lastPageLink = makePage(totalPages, totalPages, false);
            pages.push(lastPageLink);
          }
        }
      }
      return pages;
    }

    var originalRender = this.render;
    this.render = function () {
      originalRender();
      if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
        $scope.pages = getPages($scope.page, $scope.totalPages);
      }
    };
  }])

  .constant('uibPaginationConfig', {
    itemsPerPage: 10,
    boundaryLinks: false,
    boundaryLinkNumbers: false,
    directionLinks: true,
    firstText: 'First',
    previousText: 'Previous',
    nextText: 'Next',
    lastText: 'Last',
    rotate: true,
    forceEllipses: false
  })

  .directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
    return {
      scope: {
        totalItems: '=',
        firstText: '@',
        previousText: '@',
        nextText: '@',
        lastText: '@',
        ngDisabled: '='
      },
      require: ['uibPagination', '?ngModel'],
      restrict: 'A',
      controller: 'UibPaginationController',
      controllerAs: 'pagination',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || '/app/common/pagination.html';
      },
      link: function (scope, element, attrs, ctrls) {
        element.addClass('pagination');
        var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if (!ngModelCtrl) {
          return; // do nothing if no ng-model
        }

        paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
      }
    };
  }]);